export const removeQueryStringFromUri = (
    url: string,
    queryString: string
): string => {
    const urlParts = url.split('?');
    if (urlParts.length < 2) return url;

    const param = encodeURIComponent(queryString) + '=';
    const parts = urlParts[1].split(/[&;]/g);

    for (let i = parts.length; i-- > 0; ) {
        if (parts[i].lastIndexOf(param, 0) !== -1) {
            parts.splice(i, 1);
        }
    }

    return urlParts[0] + (parts.length > 0 ? '?' + parts.join('&') : '');
};
